<script setup lang="ts">
import { useStorage } from '@vueuse/core'

const showNav = useStorage('showNav', true)
const { name: orgName, iconUrl: orgIconUrl } = useOrgMetadata()
</script>

<template>
  <div class="mt-3 flex items-center justify-between px-2">
    <UButton
      :icon="orgIconUrl ? undefined : 'brands:sleuth'"
      variant="ghost"
      color="white-nav"
      to="/"
      :title="orgName"
      :ui="{ base: '!p-2 min-w-0 !shrink overflow-hidden', icon: { base: 'size-6 shrink-0' } }"
      class="min-w-0 flex-1"
    >
      <template v-if="orgIconUrl" #leading>
        <img :src="orgIconUrl" alt="Organization icon" class="size-6 shrink-0 rounded object-cover" />
      </template>
      <span class="truncate">{{ orgName }}</span>
    </UButton>

    <div class="flex shrink-0 items-center">
      <UButton
        :icon="showNav ? 'solid:sidebar' : 'solid:sidebar-flip'"
        variant="ghost"
        color="white-nav"
        size="xs"
        data-action="hide-nav-button"
        class="!text-gray-500 ring-0 transition-[shadow,transform]"
        :class="{ 'translate-x-14 ring-1 ring-gray-200': !showNav }"
        :ui="{ base: '!p-2', icon: { size: { xs: 'size-[0.875rem]' } } }"
        @click="showNav = !showNav"
      />
    </div>
  </div>
</template>
